package one.healthium.profile.ui.update_name

import androidx.compose.runtime.Immutable
import one.healthium.domain.user.UserModel

@Immutable
internal data class UpdateNameUiState(
    val loading: Boolean = false,
    val userModel: UserModel? = null,
    val updatedName: String? = null,
) {
    val name = updatedName ?: userModel?.profile?.name
    val isNameChanged = updatedName != null && updatedName.trim() != userModel?.profile?.name
}
